import React from 'react'
import {
  Container,
  Row,
  Col,
  Table
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'

const CloudParentsList = ({ modelList, filterDepartmentSelect, filterBusinessUnitSelect, onChangeFilter, isLoading }) => {
  return (
    <Container fluid>
      <Row>
        <Col lg={{ size: 6, offset: 3}}>
          <h1 className="text-center">Cloud Parents Table</h1>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
            <IgtLoader isLoading={isLoading}/>
            :
            <Table hover>
              <thead className='sticky-header'>
                <tr>
                  <th>Terminated (yes/no)</th>
                  <th>Cloud</th>
                  <th>Identifier</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Owner</th>
                  <th>Business Unit</th>
                  <th>Department</th>
                  <th>Environment</th>
                  <th>Cost Center</th>
                </tr>
              </thead>
              <tbody>
                {
                  modelList && modelList.map((parent, i) => {
                    return (
                      <ListItem
                        modelListItem={parent}
                        key={i}
                        index={i}
                      />
                    )
                  })
                }
              </tbody>
            </Table>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default CloudParentsList